import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const BusinessesDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Agencies/Companies'
    directoryProvider={PROVIDERS.BUSINESS}
    directoryBasePath={PROVIDERS.BUSINESS.profilesBasePath}
    directoryResultsType={RESULTS_TYPES.PROFILES}
  />
)

export default BusinessesDirectories
